import * as React from "react";
import { Route, Switch } from "react-router";
import { ERoutes } from "../../../../ERoutes";
import { PersonJudgeTabs } from "./PersonJudgeTabs";

export interface IPersonJudgeSwitchProps {}

export const PersonJudgeSwitch: React.FunctionComponent<IPersonJudgeSwitchProps> = (props) => {
  return (
    <Switch>
      <Route path={`${ERoutes.people}/:id/:tab/:state/:judgeTab?`} component={PersonJudgeTabs} />
    </Switch>
  );
};
